/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateInspectionDataDto } from '../../models/create-inspection-data-dto';
import { InspectionDataDto } from '../../models/inspection-data-dto';

export interface InspectionDataControllerCreate$Params {
      body: CreateInspectionDataDto
}

export function inspectionDataControllerCreate(http: HttpClient, rootUrl: string, params: InspectionDataControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<InspectionDataDto>> {
  const rb = new RequestBuilder(rootUrl, inspectionDataControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InspectionDataDto>;
    })
  );
}

inspectionDataControllerCreate.PATH = '/api/inspection-data';
